import styled from 'styled-components'

const MyDiv = styled.div`
.btn_theme{
    background: #176de5;
    font-size: 14px;
    text-transform: capitalize;
    font-family: "Arial";
  }
.btn_theme:hover{
  background: #176de5;
}
.btn_reset{
    background: #f0ad4e;
    font-size: 14px;
    text-transform: capitalize;
    font-family: "Arial";
}
.btn_reset:hover{
  background: #f0ad4e;
}

  // .disable_action{
  //   background: #eee;
  //   color: #333!important;
  //   font-size: 0.9rem!important;
  //   text-transform: capitalize!important;
  // }
  // .disable_action:hover{
  //   background: #eee!important;
  //   color: #333!important;
  //   font-size: 0.9rem!important;
  //   text-transform: capitalize!important;
  // }
  // .progress_text{
  //   padding-left:10px;
  // }
  // .progress_icon{
  //   color: #283c86;
  // }
`
export default MyDiv
